import { useState } from 'react'
import { CategoriesTab } from './tabs/CategoriesTab'
import { SizesTab } from './tabs/SizesTab'
import { ColoursTab } from './tabs/ColoursTab'
import { MaterialsTab } from './tabs/MaterialsTab'
import { SizeGuidesTab } from './tabs/SizeGuidesTab'
import { CollectionsTab } from './tabs/CollectionsTab'
import { OccasionsTab } from './tabs/OccasionsTab'

const TABS = ['Categories', 'Collections', 'Occasions', 'Sizes', 'Colours', 'Materials', 'Size Guides'] as const
type Tab = typeof TABS[number]

export const ProductMetadataPage = () => {
  const [activeTab, setActiveTab] = useState<Tab>('Categories')

  return (
    <div className="py-6">
      <div className="mb-8">
        <h1 className="text-[23px] font-bold text-foreground">Product Metadata</h1>
        <p className="text-[14px] text-muted-foreground mt-1">Manage categories, collections, occasions, sizes, colours, materials and size guides</p>
      </div>

      <div className="flex gap-1 border-b border-[#E5E7EB] mb-8 overflow-x-auto">
        {TABS.map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-3 text-[13px] font-[600] transition-colors border-b-2 -mb-[2px] whitespace-nowrap ${
              activeTab === tab
                ? 'border-[#3F3E42] text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {activeTab === 'Categories' && <CategoriesTab />}
      {activeTab === 'Collections' && <CollectionsTab />}
      {activeTab === 'Occasions' && <OccasionsTab />}
      {activeTab === 'Sizes' && <SizesTab />}
      {activeTab === 'Colours' && <ColoursTab />}
      {activeTab === 'Materials' && <MaterialsTab />}
      {activeTab === 'Size Guides' && <SizeGuidesTab />}
    </div>
  )
}
